const config = {
	pusher: {
		appKey: import.meta.env.VITE_PUSHER_APP_KEY || "ecc31e180fdb89dca999",
		cluster: import.meta.env.VITE_PUSHER_CLUSTER || "eu",
	},
};

export default config as typeof config;
